import React, { useEffect, useState } from 'react';
import { Col, Form, message } from 'antd';
import Select from 'components/Select';
import { getEnumValues, padronesEnum, solicitantesEnum } from 'views/Tramites/GPM/enums';
import PropTypes from 'prop-types';
import { InputSearchPro } from 'components/InputSearch';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import padronToString from 'utils/padronesToString';
import { getPadronesMap } from 'api/recaudacion/utils';

const propsMap = {
  [padronesEnum.EMPRESA]: {
    getName: (ciudadano) => (ciudadano ? 'ciudadano' : 'contribuyente'),
  },
  [padronesEnum.VEHICULO]: {
    nameTipoDePropietario: 'es_propietario_ciudadano',
    labelTipoDePropietario: 'Tipo de propietario',
    selectProps: { trueFalse: ['Ciudadano', 'Contribuyente'] },
    getName: (es_propietario_ciudadano) => (es_propietario_ciudadano
      ? 'propietario' : 'contribuyente_propietario'),
  },
  [padronesEnum.CONTRIBUYENTE]: {
    getTipoDePadron: () => padronesEnum.CIUDADANO,
    getName: () => 'ciudadano',
  },
  [padronesEnum.MOTOCICLETA]: {
    nameTipoDePropietario: 'es_propietario_ciudadano',
    labelTipoDePropietario: 'Tipo de propietario',
    selectProps: { trueFalse: ['Ciudadano', 'Contribuyente'] },
    getName: (es_propietario_ciudadano) => (es_propietario_ciudadano
      ? 'propietario' : 'contribuyente_propietario'),
  },
  [padronesEnum.REMOLQUE]: {
    nameTipoDePropietario: 'es_propietario_ciudadano',
    labelTipoDePropietario: 'Tipo de propietario',
    selectProps: { trueFalse: ['Ciudadano', 'Contribuyente'] },
    getName: (es_propietario_ciudadano) => (es_propietario_ciudadano
      ? 'ciudadano_propietario' : 'contribuyente_propietario'),
  },
  [padronesEnum.PREDIO]: {
    nameTipoDePropietario: 'es_propietario_ciudadano',
    labelTipoDePropietario: 'Tipo de propietario',
    selectProps: { trueFalse: ['Ciudadano', 'Contribuyente'] },
    getName: (es_propietario_ciudadano) => (es_propietario_ciudadano
      ? 'ciudadano' : 'contribuyente'),
  },
};

const CambioPropietario = ({
  tipoDePadronAfectado,
  padronAfectado,
  disabled,
  setLoading,
  padronSolicitante,
  tipoPadronSolicitante,
}) => {
  const form = Form.useFormInstance();
  const [dataSource, setDataSource] = useState();
  const [dataSourceAlt, setDataSourceAlt] = useState();
  const [propietarioActual, setPropietarioActual] = useState();

  const {
    nameTipoDePropietario = '',
    labelTipoDePropietario = '',
    selectProps = {},
    getTipoDePadron = () => null,
    getName = () => null,
  } = propsMap[tipoDePadronAfectado] || {};

  const ciudadanoProp = getName(true);
  const contribuyenteProp = getName(false);
  const es_propietario_ciudadano = !nameTipoDePropietario
    || Form.useWatch(['valuesCambio', nameTipoDePropietario], form);
  const namePropietario = getName(es_propietario_ciudadano);
  const tipoDePadron = (getTipoDePadron && getTipoDePadron())
    || es_propietario_ciudadano ? padronesEnum.CIUDADANO : padronesEnum.CONTRIBUYENTE;

  const namePropietarioActual = getName(!!padronAfectado[ciudadanoProp]);
  const tipoDePadronPropietarioActual = (getTipoDePadron && getTipoDePadron())
    || padronAfectado[ciudadanoProp] ? padronesEnum.CIUDADANO : padronesEnum.CONTRIBUYENTE;
  const _propietario = padronAfectado[namePropietarioActual];

  const solicitanteIsNotPropietario = (_propietario?.id || _propietario) !== padronSolicitante.id
    || tipoPadronSolicitante !== tipoDePadronPropietarioActual;

  const isEmpresa = tipoDePadronAfectado === padronesEnum.EMPRESA;
  const noRelationCiudadano = { id: null, nombre_completo: 'No relacionar ciudadano' };
  const noRelationContribuyente = { id: null, razon_social: 'No relacionar contribuyente' };

  const searchRelated = async (_tipoDePadron, padron) => {
    if (!isEmpresa) return;
    const relatedToCiudadano = _tipoDePadron === padronesEnum.CIUDADANO;
    const _params = {};
    if (relatedToCiudadano) {
      _params.tipo_de_persona = 1;
      _params.ciudadano = padron.id;
    } else {
      _params.id = padron.ciudadano?.id;
    }
    const _dataSourceAlt = [relatedToCiudadano ? noRelationContribuyente : noRelationCiudadano];
    const setter = relatedToCiudadano ? setDataSourceAlt : setDataSource;
    if (_params.id || _params.ciudadano) {
      setLoading(true);
      const values = { valuesCambio: {} };
      const responseAlt = await getPadronesMap[relatedToCiudadano
        ? padronesEnum.CONTRIBUYENTE : padronesEnum.CIUDADANO](_params);
      if (responseAlt.results.length === 1) {
        const _namePropietarioAlt = getName(!relatedToCiudadano);
        values.valuesCambio[_namePropietarioAlt] = responseAlt.results[0].id;
        _dataSourceAlt.push(responseAlt.results[0]);
        form.setFieldsValue(values);
      }
    }
    setter(_dataSourceAlt);
    setLoading(false);
  };

  const fetchPropietarioActual = async () => {
    setLoading(true);
    const params = { id: _propietario?.id || _propietario };
    const response = await getPadronesMap[tipoDePadronPropietarioActual](params);
    const values = { valuesCambio: {} };
    const [_propietarioActual] = response.results;
    if (!disabled) {
      setPropietarioActual(_propietarioActual);
      values.propietario_actual = _propietarioActual.id;
    }
    if (disabled || (!disabled && solicitanteIsNotPropietario)) {
      const pivot = disabled ? _propietarioActual : padronSolicitante;
      const tipoDePadronPivot = disabled ? tipoDePadronPropietarioActual : tipoPadronSolicitante;
      const pivotIsCiudadano = tipoDePadronPivot === padronesEnum.CIUDADANO;
      const _namePropietario = getName(pivotIsCiudadano);
      values.valuesCambio[_namePropietario] = pivot.id;
      values.valuesCambio
        .es_propietario_ciudadano = tipoDePadronPivot === padronesEnum.CIUDADANO;
      const setter = (!isEmpresa && setDataSource)
        || pivotIsCiudadano ? setDataSource : setDataSourceAlt;
      if (isEmpresa) {
        setter([pivotIsCiudadano ? noRelationCiudadano : noRelationContribuyente, pivot]);
      } else {
        setter([pivot]);
      }
      if (isEmpresa) {
        const _params = {};
        if (pivotIsCiudadano) {
          _params.tipo_de_persona = 1;
          _params.ciudadano = pivot.id;
        } else {
          _params.id = pivot.ciudadano?.id;
        }
        const setterAlt = pivotIsCiudadano ? setDataSourceAlt : setDataSource;
        const _dataSourceAlt = [pivotIsCiudadano ? noRelationCiudadano : noRelationContribuyente];
        if (!(_params.id || _params.ciudadano)) {
          setLoading(false);
          form.setFieldsValue(values);
          setterAlt(_dataSourceAlt);
          return;
        }
        const responseAlt = await getPadronesMap[pivotIsCiudadano
          ? padronesEnum.CONTRIBUYENTE : padronesEnum.CIUDADANO](_params);
        if (responseAlt.results.length !== 1) {
          setLoading(false);
          form.setFieldsValue(values);
          return;
        }
        const _namePropietarioAlt = getName(!pivotIsCiudadano);
        values.valuesCambio[_namePropietarioAlt] = responseAlt.results[0].id;
        values.valuesCambio
          .es_propietario_ciudadano = tipoDePadronPivot === padronesEnum.CIUDADANO;
        _dataSourceAlt.push(responseAlt.results[0]);
        setterAlt(_dataSourceAlt);
      }
    }
    setLoading(false);
    form.setFieldsValue(values);
  };

  useEffect(() => {
    if (!propsMap[tipoDePadronAfectado]) return;
    const values = { valuesCambio: {} };
    if (!disabled && nameTipoDePropietario) {
      values.valuesCambio[namePropietario] = padronAfectado[namePropietario];
      values.valuesCambio[nameTipoDePropietario] = padronAfectado[nameTipoDePropietario];
    }
    form.setFieldsValue(values);
    setTimeout(() => fetchPropietarioActual());
  }, [disabled, padronAfectado]);

  const onPressEnter = async (origin) => {
    const _tipoDePadron = origin === 'q' ? padronesEnum.CIUDADANO : padronesEnum.CONTRIBUYENTE;
    setLoading(true);
    const { [origin]: q } = form.getFieldsValue();
    if (q) {
      const response = await getPadronesMap[_tipoDePadron]({ q });
      if (response.results.length === 1) {
        const [match] = response.results;
        const values = { valuesCambio: {}, [origin]: undefined };
        values.valuesCambio = {
          [getName(_tipoDePadron === padronesEnum.CIUDADANO)]: match.id,
        };
        form.setFieldsValue(values);
        if (isEmpresa) {
          const setter = _tipoDePadron === padronesEnum.CIUDADANO
            ? setDataSource : setDataSourceAlt;
          setter([_tipoDePadron === padronesEnum.CIUDADANO
            ? noRelationCiudadano : noRelationContribuyente, match]);
        } else {
          setDataSource(match);
        }
        await searchRelated(_tipoDePadron, match);
      } else if (response.results.length) {
        message.info('Ingrese una búsqueda más específica');
      } else {
        message.info('No se encontraron resultados');
      }
    }
    setLoading(false);
  };

  const getLabel = (_tipoDePadron) => `Propietario ${disabled
    ? '' : 'Nuevo'} ${_tipoDePadron === padronesEnum.CIUDADANO ? '(Ciudadano)' : '(Contribuyente)'}`;

  const getTooltip = (_tipoDePadron) => `Búsqueda por clave ${
    _tipoDePadron === padronesEnum.CIUDADANO ? 'ciudadana' : ''}, correo eléctrónico y nombre completo`;

  const onClear = disabled || solicitanteIsNotPropietario ? null : () => {
    setDataSource();
    form.resetFields([namePropietario]);
    if (isEmpresa) {
      setDataSourceAlt();
      form.resetFields([getName(false)]);
    }
  };

  const onClearAlt = disabled || solicitanteIsNotPropietario ? null : () => {
    setDataSourceAlt();
    form.resetFields([getName(false)]);
    onClear();
  };

  if (!propsMap[tipoDePadronAfectado]) return 'Cambio de propietario no definido para padrón actual';

  return (
    <>
      {!disabled && (
        <>
          <Col xs={24} sm={24} md={16}>
            <Form.Item name="propietario_actual" label="Propietario actual">
              <Select
                disabled
                dataSource={[propietarioActual]}
                render={(record) => padronToString(record, tipoDePadronPropietarioActual, true)}
                placeholder="Sin propietario"
              />
            </Form.Item>
          </Col>
          <Col xs={0} sm={0} md={8} />
        </>
      )}
      {!!nameTipoDePropietario && (
        <Col xs={24} sm={24} md={8}>
          <Form.Item name={['valuesCambio', nameTipoDePropietario]} label={labelTipoDePropietario}>
            <Select
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...selectProps}
              disabled={disabled || selectProps.disabled
                || !(Array.isArray(dataSource) ? dataSource.length : dataSource)}
            />
          </Form.Item>
        </Col>
      )}
      {isEmpresa ? (
        <>
          <InputSearchPro
            advancedComponent={BusquedaAvanzadaPadrones}
            advancedComponentProps={{ tipoDePadron: padronesEnum.CIUDADANO, allowAdd: false }}
            label={getLabel(padronesEnum.CIUDADANO)}
            tooltip={getTooltip(padronesEnum.CIUDADANO)}
            resultProps={{
              name: ['valuesCambio', namePropietario],
              label: getLabel(padronesEnum.CIUDADANO),
              render: (_padron) => padronToString(_padron, padronesEnum.CIUDADANO),
              dataSource,
              setDataSource: (item) => {
                setDataSource(isEmpresa ? [noRelationCiudadano, item] : [item]);
                const values = { valuesCambio: {}, q: undefined };
                values.valuesCambio = { [namePropietario]: item.id };
                form.setFieldsValue(values);
                searchRelated(padronesEnum.CIUDADANO, item);
              },
              allowClear: true,
              onClear,
              breakPoints: { md: 16 },
              rules: [
                ({ getFieldValue }) => ({
                  validator: async (rule, _value) => {
                    if (!_value && !getFieldValue(['valuesCambio', 'contribuyente'])) {
                      throw new Error('Debe asignar al menos Ciudadano o Contribuyente');
                    }
                  },
                }),
              ],
            }}
            inputProps={{ onPressEnter }}
            breakPoints={{ md: 16 }}
            rules={[
              ({ getFieldValue }) => ({
                validator: async (rule, _value) => {
                  if (!_value && !getFieldValue(['valuesCambio', 'contribuyente'])) {
                    throw new Error('Debe asignar al menos Ciudadano o Contribuyente');
                  }
                },
              }),
            ]}
            disabled={disabled}
          />
          <InputSearchPro
            advancedComponent={BusquedaAvanzadaPadrones}
            advancedComponentProps={{ tipoDePadron: padronesEnum.CONTRIBUYENTE, allowAdd: false }}
            label={getLabel(padronesEnum.CONTRIBUYENTE)}
            tooltip={getTooltip(padronesEnum.CONTRIBUYENTE)}
            resultProps={{
              name: ['valuesCambio', contribuyenteProp],
              label: getLabel(padronesEnum.CONTRIBUYENTE),
              render: (_padron) => padronToString(_padron, padronesEnum.CONTRIBUYENTE),
              dataSource: dataSourceAlt,
              setDataSource: (item) => {
                setDataSourceAlt([noRelationContribuyente, item]);
                const values = { valuesCambio: {}, q_alt: undefined };
                values.valuesCambio = { [contribuyenteProp]: item.id };
                form.setFieldsValue(values);
                searchRelated(padronesEnum.CONTRIBUYENTE, item);
              },
              allowClear: true,
              onClear: onClearAlt,
              breakPoints: { md: 16 },
              rules: [
                ({ getFieldValue }) => ({
                  validator: async (rule, _value) => {
                    if (!_value && !getFieldValue(['valuesCambio', 'ciudadano'])) {
                      throw new Error('Debe asignar al menos Ciudadano o Contribuyente');
                    }
                  },
                }),
              ],
            }}
            inputProps={{ onPressEnter }}
            rules={[
              ({ getFieldValue }) => ({
                validator: async (rule, _value) => {
                  if (!_value && !getFieldValue(['valuesCambio', 'ciudadano'])) {
                    throw new Error('Debe asignar al menos Ciudadano o Contribuyente');
                  }
                },
              }),
            ]}
            breakPoints={{ md: 16 }}
            name="q_alt"
            disabled={disabled}
          />
        </>
      ) : (
        <InputSearchPro
          advancedComponent={BusquedaAvanzadaPadrones}
          advancedComponentProps={{ tipoDePadron, allowAdd: false }}
          label={getLabel(tipoDePadron)}
          tooltip={getTooltip(tipoDePadron)}
          resultProps={{
            name: ['valuesCambio', namePropietario],
            label: getLabel(tipoDePadron),
            render: (_padron) => padronToString(_padron, tipoDePadron),
            dataSource,
            setDataSource: (item) => {
              setDataSource([item]);
              const values = { valuesCambio: {}, q: undefined };
              values.valuesCambio = { [namePropietario]: item.id };
              form.setFieldsValue(values);
            },
            allowClear: true,
            onClear,
            breakPoints: { md: 16 },
            rules: [{ required: true }],
          }}
          inputProps={{ onPressEnter }}
          breakPoints={{ md: 16 }}
          rules={[{ required: true }]}
          disabled={disabled}
          disabledOnResult={disabled}
        />
      )}
    </>
  );
};

CambioPropietario.propTypes = {
  tipoDePadronAfectado: PropTypes.oneOf(getEnumValues(padronesEnum)),
  padronAfectado: PropTypes.shape({}),
  tipoPadronSolicitante: PropTypes.oneOf(getEnumValues(solicitantesEnum)),
  padronSolicitante: PropTypes.shape({ id: PropTypes.number, ciudadano: PropTypes.shape({}) }),
  disabled: PropTypes.bool,
  setLoading: PropTypes.func.isRequired,
};

CambioPropietario.defaultProps = {
  tipoDePadronAfectado: null,
  padronAfectado: null,
  tipoPadronSolicitante: null,
  padronSolicitante: null,
  disabled: false,
};

export default CambioPropietario;
